import React from "react";
import VslSixBottles from "../../../../assets/respo-fe-6.png"
import freeshipping from "../../../../assets/free-shipping.png"


const WhyOrder = () => {
  return (
    <div
    >
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="flex items-center gap-5 flex-col justify-center">
          <h1 className="text-4xl  font-bold text-center md:mb-12">
            Here's Why You Should Order 6 Bottles...
          </h1>
          <div className="w-36 h-1.5 bg-[#d9d9d9]" />

          <div className="max-w-4xl mx-auto grid md:grid-cols-3 gap-8 items-start">
            {/* Left Column - Product Images */}
            <div className="space-y-0 md:col-span-1 col-span-3">
              <div className="flex justify-center">
                <img
                  src="https://cdn.blackincae.com/respoclear/xwH-vsl6bottles-1-.png"
                  alt="6 bottles of Breathe with bonuses"
                  className="md:w-full w-2/3 "
                />
              </div>
              <div className="text-center text-8xl font-bold ">+</div>
              <div className="flex justify-center">
                <img
                  src={freeshipping}
                  alt="3 bottles of Breathe with bonuses"
                  className="md:w-full w-2/3 "
                />
              </div>
            </div>

            {/* Right Column - Content */}
            <div className="space-y-2 md:col-span-2 col-span-3 ">
              <p className="text-[22px] font-light">
                When you order in bulk, we save on shipping costs—and it’s only fair to pass those savings ( <span className="text-[#ff1300] font-bold">up to $840 in savings for 6 bottles</span>) directly to you when you order Respoclear today!
              </p>

              <div>
                <h2 className=" text-[22px] font-bold mb-4">
                  Something this transformative will not stay in stock for long, and here’s why:

                </h2>
                <ul className="space-y-1 text-[22px] font-light">
                  <li className="flex gap-2">
                    <span>1.</span>
                    <p>
                      Respoclear is in <span className="font-bold">{" "}
                        incredibly high demand
                      </span> and is flying off the shelves...
                    </p>
                  </li>
                  <li className="flex gap-2">
                    <span>2.</span>
                    <p>
                      The rare sinus-clearing ingredients in Respoclear are sourced from limited, high-quality suppliers...

                    </p>
                  </li>
                  <li className="flex gap-2">
                    <span>3.</span>
                    <p>
                      It can take <span className="font-bold">{" "}up to 3 months to craft and restock a new batch</span> of Respoclear...

                    </p>
                  </li>
                  <li className="flex gap-2">
                    <span>4.</span>
                    <p>
                      Powerful lobbyists in the pharmaceutical industry keep trying to block natural solutions like ours!

                    </p>
                  </li>
                </ul>
              </div>

              <p className="text-[22px] font-light"> That’s why ( <span className="font-bold text-[#ff1300]">our sharpest Respoclear customers stock up on the 6-month supply—ensuring</span> they never miss a day of clear, effortless breathing while avoiding out-of-stock frustrations!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyOrder;
